module.exports = __webpack_public_path__ + "static/media/robot-success.b9e70375.svg";